import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, api } from '../contexts/AuthContext';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const industries = ['Construction & Trades', 'Manufacturing', 'Healthcare', 'Hospitality', 'Retail', 'Logistics & Transport', 'Agriculture', 'Mining', 'Professional Services', 'Education', 'Technology', 'Other'];

export default function OnboardingPage() {
  const [companyName, setCompanyName] = useState('');
  const [industry, setIndustry] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user && user.onboarded) navigate('/dashboard');
    if (user === false) navigate('/auth');
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!companyName.trim() || !industry) { setError('Please fill in all fields'); return; }
    setLoading(true); setError('');
    try { await api.post(`/api/onboarding`, { company_name: companyName, industry }); await refreshUser(); navigate('/dashboard'); }
    catch (err) { setError(err.response?.data?.detail || 'Failed to set up company'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#080812] flex items-center justify-center p-4" data-testid="onboarding-page">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <img src="/distill-logo.png" alt="Distill" className="h-20 mx-auto mb-4" />
          <h1 className="text-3xl font-semibold text-white mb-2">Set up your company</h1>
          <p className="text-[#9CA3AF]">Just a couple of details to get started</p>
        </div>

        <div className="bg-[#111827] rounded-lg border border-[#374151] p-8">
          {error && <div className="mb-4 p-3 rounded-md bg-red-500/10 border border-red-500/30 text-sm text-red-400" data-testid="onboarding-error">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="text-[#F9FAFB]">Company Name</Label>
              <Input value={companyName} onChange={(e) => setCompanyName(e.target.value)} placeholder="Acme Plumbing Co." className="mt-1.5 bg-[#1F2937] border-[#374151] text-[#F9FAFB] placeholder:text-[#9CA3AF]" data-testid="onboarding-company-input" />
            </div>
            <div>
              <Label className="text-[#F9FAFB]">Industry</Label>
              <Select value={industry} onValueChange={setIndustry}>
                <SelectTrigger className="mt-1.5 bg-[#1F2937] border-[#374151] text-[#F9FAFB]" data-testid="onboarding-industry-select"><SelectValue placeholder="Select your industry" /></SelectTrigger>
                <SelectContent className="bg-[#111827] border-[#374151]">{industries.map(ind => <SelectItem key={ind} value={ind} className="text-[#F9FAFB] focus:bg-[#1F2937]">{ind}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#AAFF00] text-[#080812] hover:bg-[#c4ff4d] h-11 font-semibold" data-testid="onboarding-submit-btn">
              {loading ? <span className="flex items-center gap-2"><span className="w-4 h-4 border-2 border-[#080812]/30 border-t-[#080812] rounded-full animate-spin" />Setting up...</span> : 'Get Started'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
